<template>
    <div>
        <v-layout fill-height row mr-1 ml-1 mt-2>
            <v-flex xs12 sm12 lg12 xl12>
                <v-card>
                    <v-toolbar dense color="secondary" dark>
                        <v-toolbar-title>{{TranslateText('Users')}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-text-field append-icon="search" v-model="searchUserString" :placeholder="TranslateText('Search users')"></v-text-field>
                    </v-toolbar>
                    <v-layout justify-center>
                        <v-flex xs3 mt-2 ml-2>
                            <v-card elevation="10">
                                <v-card-title primary-title>
                                    <div class="title">
                                        {{ Total }}
                                    </div>
                                    <v-icon size=20>equalizer</v-icon>
                                    <v-spacer></v-spacer>
                                    <div class="title">
                                        {{TranslateText('User(s)')}}
                                    </div>
                                </v-card-title>
                            </v-card>
                        </v-flex>
                        <v-flex xs3 mt-2 ml-2>
                            <v-card color="error --darken-1" elevation="10">
                                <v-card-title primary-title>
                                    <div class="title">
                                        {{ TotalInactive }}
                                    </div>
                                    <v-icon size=20>equalizer</v-icon>
                                    <v-spacer></v-spacer>
                                    <div class="title">
                                        {{TranslateText('Inactive User(s)')}}
                                    </div>
                                </v-card-title>
                            </v-card>
                        </v-flex>
                        <v-flex xs3 mt-2 ml-2>
                            <v-card color="success --darken-2" elevation="10">
                                <v-card-title primary-title>
                                    <div class="title">
                                        {{ TotalActive }}
                                    </div>
                                    <v-icon size=20>equalizer</v-icon>
                                    <v-spacer></v-spacer>
                                    <div class="title">
                                        {{TranslateText('Active User(s)')}}
                                    </div>
                                </v-card-title>
                            </v-card>
                        </v-flex>

                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm12 md12 lg12 xl12>
                            <UserList :search="searchUserString" />
                        </v-flex>
                        <!-- <v-flex xs12 sm12 md3 lg3 xl3>
                            <UserDetailSelect />
                        </v-flex> -->
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import UserList from '@/components/common/account/account-users-list.vue'

    export default {
        data() {
            return {
                TotalActive: 0,
                TotalInactive: 0,
                Total: 0,
                searchUserString: null
            }
        },
        components: {
            UserList,
        },
        mounted() {
            let self = this;
            self.FetchData();
        },
        methods: {
            FetchData() {
                let self = this;
                self.get('SystemUser/Counters')
                    .then(response => {
                        self.TotalActive = response.data.TotalActive;
                        self.TotalInactive = response.data.TotalInactive;
                        self.Total = response.data.TotalUsers;
                    })
                    .catch(error => {

                    })
            }
        }
    }
</script>

<style>

</style>